@if (form) {
  <form [formGroup]="form">
    <label>{{ 'ONBOARDING_CHANGE_LANGUAGE_LABEL' | translate }}</label>
    <em-select formControlName="language">
      <em-option>--</em-option>
      @for (language of languages; track language) {
        <em-option [value]="language">
          <div class="label">{{ i18nLanguageKey(language) | translate }}</div>
        </em-option>
      }
      @if (form?.controls.language.hasError('required')) {
        <em-error>{{
          'VALIDATION_FIELD_REQUIRED' | translate
        }}</em-error>
      }
    </em-select>
  </form>
}
